<template>
  <d2-container>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      v-loading="listLoading"
      highlight-current-row
      style=" margin-top: 20px"
      :data="getCardList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="打卡活动id">
        <template slot-scope="scope">
          <span>{{ scope.row.clockThemeId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="委托方名称">
        <template slot-scope="scope">
          <span>{{ scope.row.companyName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="委托方图标">
        <template slot-scope="scope">
          <img :src="scope.row.companyIcon" style="width:60px;height:60px;object-fit: cover" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="卡片名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="实际已完成数量">
        <template slot-scope="scope">
          <span>{{ scope.row.doneCount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="实际可领取数量">
        <template slot-scope="scope">
          <span>{{ scope.row.limitCount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="已领取数量">
        <template slot-scope="scope">
          <span>{{ scope.row.receiveCount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="已进行数量">
        <template slot-scope="scope">
          <span>{{ scope.row.commitCount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="实际库存">
        <template slot-scope="scope">
          <span>{{ scope.row.limitCount - scope.row.receiveCount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="实际已抽取数量">
        <template slot-scope="scope">
          <span>{{ scope.row.drawCount }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="奖品名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name}}</span>
        </template>
      </el-table-column> -->
      <el-table-column align="center" label="虚拟已抽取数量">
        <template slot-scope="scope">
          <span>{{ scope.row.virtualDrawCount}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="虚拟库存">
        <template slot-scope="scope">
          <span>{{ scope.row.virtualLimitCount - scope.row.virtualDrawCount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="虚拟可领取数量">
        <template slot-scope="scope">
          <span>{{ scope.row.virtualLimitCount}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="酬劳">
        <template slot-scope="scope">
          <span>{{ scope.row.reward}}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" fixed="right" width="110">
        <template slot-scope="scope">
          <el-button
            @click="getStock(scope.row.id)"
            size="small"
            type="success"
            style="margin-top: 10px;"
          >增加库存</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="增加库存" :visible.sync="dialogFormStock">
      <el-form :model="form" :rules="rules" ref="form" label-width="170px">
        <el-form-item label="数量" prop="count">
          <el-input v-model.number="form.count" placeholder="请输入数量"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button type="primary" @click="create('form')">确 定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>
<script>
import { getCard, getStock } from '@/api/demo/CommissionRelate/index'
import { mapGetters } from 'vuex'
export default {
  name: 'delegationDetails',
  computed: {
    ...mapGetters(['elements'])
  },
  data () {
    return {
      id: '',
      getCardList: [],
      tableKey: 0,
      listLoading: true, // 加载圈圈
      form: {
        count: null
      },
      stockId: null, // 卡片id
      dialogFormStock: false, // 增加库存弹窗
      rules: {
        count: [
          { required: true, message: '请输入数量' },
          { type: 'number', message: '数量必须为数字值' },
          {
            pattern: /^\+?[1-9][0-9]*$/,
            message: '请输入大于0的整数',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.id = this.$route.query.id
    if (this.id != null) {
      this.getCardsList(this.id)
    }
  },
  mounted () {},
  methods: {
    getCardsList (id) {
      this.listLoading = true
      getCard(id).then(res => {
        this.getCardList = res
        this.listLoading = false
      })
    },
    // 增加库存
    getStock (id) {
      this.stockId = id
      this.dialogFormStock = true
    },
    // 取消增加库存
    cancel (formName) {
      this.dialogFormStock = false
      this.$refs[formName].resetFields()
    },
    // 确认增加库存
    create () {
      let that = this
      this.dialogFormStock = false
      getStock(that.stockId, that.form).then(res => {
        that.$notify({
          title: '成功',
          message: '增加成功',
          type: 'success',
          duration: 2000
        })
        getCard(that.id).then(res => {
          that.getCardList = res
        })
      })
    }
  }
}
</script>

<style>
</style>
